import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

export const WHOLESALE_CUSTOMER_SUCCESS = 'WHOLESALE_CUSTOMER_SUCCESS';
export const WHOLESALE_CUSTOMER_LOADING = 'WHOLESALE_CUSTOMER_LOADING';

const { wholesaleCustomer: { getWholesaleCustomer } } = apiUrls;


export const getCustomerDetails = () => async (dispatch) => {
  try {

    const data = await REQUEST(getWholesaleCustomer);
    dispatch({
      type: WHOLESALE_CUSTOMER_SUCCESS,
      data,
    })
  } catch (e) {

    dispatch({
      type: WHOLESALE_CUSTOMER_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      }
    })
  }

}

export const handleLoader = isLoading => (dispatch) => {
  dispatch({
    type: WHOLESALE_CUSTOMER_LOADING,
    isLoading
  })
}
